import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import { P, SectionHeading, SectionSubHeading, SectionWrapper } from "../../Styles/style";
import Partner1 from "../../../assets/images/1.png"
import Partner2 from "../../../assets/images/2.png"
import Partner3 from "../../../assets/images/3.png"
import Partner4 from "../../../assets/images/arbscan.png"

import commfoc from "../../../assets/images/commfoc.png"

const AboutImage = styled.img`
  width: 100%;
  height: auto;
  /* max-width: 80%; */
`;
const VideoBK = styled.video`
  object-fit: cover;
  width: 100%;
  max-width: 100%;
  height: auto;
`; const GridHEading = styled(Grid)`
/* padding: 50px 0; */
align-items: center;
place-content: ${(props) => (props.pc ? props.pc : "")};
`;
const GridImage = styled(Grid)`
padding: 50px 0;
/* place-content: ${(props) => (props.pc ? props.pc : "center")};
text-align: center; */
text-align: left;
box-sizing: border-box;
margin: 20px 0px;
flex-direction: row;
flex-basis: 100%;
-webkit-box-flex: 0;
flex-grow: 0;
max-width: 100%;
text-align: center;
display: grid;
grid-template-columns: auto auto auto auto;
gap: 22px 10px;
place-items: center;

@media (max-width: 922px) {
  grid-template-columns: auto auto auto;
  place-items: center;
  text-align: center;
}

@media (max-width: 742px) {
  grid-template-columns: auto auto ;
  place-items: center;
  text-align: center;
}
@media (max-width: 549px) {
  grid-template-columns: auto  ;
  place-items: left;
  text-align: left;
}


`;
const JOiningLinks = styled.img`
  /* width: 100%;
  max-width: ${(props) => (props.mw ? props.mw : "180PX")};
  @media screen and (max-width:599px){
   max-width: ${(props) => (props.mw ? props.mw : "140PX")};

 } */
`
const FeatureWrapper = styled.div`
 background: 
    linear-gradient(#000000 0 0) padding-box, /*this is your grey background*/
    linear-gradient(319deg, #000,#000,#000, #1765FF) border-box;
  border: 1px solid transparent;
backdrop-filter: blur(13px) !important;
  padding: 20px;
`
const S2_Aboutus = () => {
  return (
    <div>
      <SectionWrapper p="8rem 0 8rem 0" p799="0" p599="0" id="features">
        <Container maxWidth="xl">
          <GridHEading container spacing={3}>
            <SectionHeading
            p="30px 0"
            m="0"
            align="center"
            data-aos="flip-up"
            data-aos-easing="ease-in"
            data-aos-delay="400"
            data-aos-duration="400"
            data-aos-offset="0"
          >SUPPORTED BLOCKCHIANS
          </SectionHeading>
            <GridImage item xs={12} md={12} 
            data-aos="fade-up" 
            data-aos-easing="ease-in"
            data-aos-delay="300"
            data-aos-duration="600"
            data-aos-offset="0"
            >
              <a href="#"
              data-aos="zoom-in-up" 
              data-aos-easing="ease-in"
              data-aos-delay="900"
              data-aos-duration="500"
              data-aos-offset="0">
              <JOiningLinks src={Partner1} />
            </a>
            <a href="#"    data-aos="zoom-in-up" 
              data-aos-easing="ease-in"
              data-aos-delay="1000"
              data-aos-duration="500"
              data-aos-offset="0">
              <JOiningLinks src={Partner2} />
            </a>
            <a href="#"    data-aos="zoom-in-up" 
              data-aos-easing="ease-in"
              data-aos-delay="1100"
              data-aos-duration="500"
              data-aos-offset="0">
              <JOiningLinks src={Partner3} />
            </a>
            <a href="#"    data-aos="zoom-in-up" 
              data-aos-easing="ease-in"
              data-aos-delay="1200"
              data-aos-duration="500"
              data-aos-offset="0">
              <JOiningLinks src={Partner4} />
            </a>
           
            </GridImage>
            {/* <GridImage item xs={12} md={6}  data-aos="fade-up" 
            data-aos-easing="ease-in"
            data-aos-delay="200"
            data-aos-duration="500"
            data-aos-offset="0">
             <FeatureWrapper>
              <JOiningLinks src={commfoc} data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="400"
                data-aos-duration="600"
                data-aos-offset="0"/>
              <SectionSubHeading data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="500"
                data-aos-duration="600"
                data-aos-offset="0">Community Focused</SectionSubHeading>
             <P
                maxWidth="90%"
                p="0 0 40px 0"
                m="0"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="600"
                data-aos-duration="600"
                data-aos-offset="0"
              >
               Our platform's community is a key structure. ArbFlow is committed to fostering a strong and supportive community by providing regular updates, engaging with our members, and responding to their feedback.</P> </FeatureWrapper>
              
           
            </GridImage> */}
          
          </GridHEading>
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default S2_Aboutus;
